/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import getPayoutState from './initial-state';

const payoutSlice = createSlice({
    name: 'payout',
    initialState: getPayoutState(),
    reducers: {
        receivePayouts: (state, { payload }) => {
            const { member, traderaPay } = payload;
            state.member = member;
            state.traderaPay = traderaPay;
            state.isFetching = false;
        },
        removePayout: (state) => {
            state.traderaPay.payoutDestination = null;
        },
        setFetching: (state, { payload }) => {
            state.isFetching = payload;
        }
    }
});

export const { receivePayouts, removePayout, setFetching } =
    payoutSlice.actions;

export default payoutSlice.reducer;

export const selectPayoutState = (state) => state.views.myTradera.payout;
